import { createStore, createHook } from 'react-sweet-state';
import Api from 'Api/Constants';
import { defaults } from 'react-sweet-state';
defaults.devtools = true;

const Store = createStore({
    // value of the store on initialisation
    initialState: {
        sisIdLabel: 'SIS ID',
        loaded: false,
        loading: false,
    },

    // actions that trigger store mutation
    actions: {
        load:
            () =>
            async ({ setState, getState }) => {
                if (getState().loading === true || getState().loaded) return;

                setState({
                    loading: true,
                });

                const sisIdLabel = await Api.getSisIdLabel();

                console.log(sisIdLabel, 'LOADED LABEL');

                setState({
                    loading: false,
                    loaded: true,
                    sisIdLabel: sisIdLabel.data.sisIdLabel,
                });
            },
    },
    // optional, mostly used for easy debugging
    name: 'sisIdLabel',
});

const useSisIdLabel = createHook(Store);

export default useSisIdLabel;
